export const FETCH_LOADS = 'FETCH_LOADS'
export const FETCH_NORMAL_LOADS = 'FETCH_NORMAL_LOADS'
export const FETCH_LOAD_BY_PARAMS = 'FETCH_LOAD_BY_PARAMS'

export const FETCH_MARKET_LOADS = 'FETCH_MARKET_LOADS'
export const FETCH_MY_LOADS = 'FETCH_MY_LOADS'
export const FETCH_REVIEW_LOADS = 'FETCH_REVIEW_LOADS'
export const FETCH_LOCKED_LOADS = 'FETCH_LOCKED_LOADS'
export const FETCH_CLOSED_LOADS = 'FETCH_CLOSED_LOADS'
export const FETCH_IN_PROGRESS_LOADS = 'FETCH_IN_PROGRESS_LOADS'

export const FETCH_INFO_LOADS = 'FETCH_INFO_LOADS'
export const FETCH_INFO_MARKET_LOADS = 'FETCH_INFO_MARKET_LOADS'
export const FETCH_INFO_MY_LOADS_LOADS = 'FETCH_INFO_MY_LOADS_LOADS'
export const FETCH_INFO_REVIEW_LOADS = 'FETCH_INFO_REVIEW_LOADS'
export const FETCH_INFO_LOCKED_LOADS = 'FETCH_INFO_LOCKED_LOADS'
export const FETCH_INFO_CLOSED_LOADS = 'FETCH_INFO_CLOSED_LOADS'

export const CLEAR_MARKET_LOADS = 'CLEAR_MARKET_LOADS'
export const CLEAR_MY_LOADS = 'CLEAR_MY_LOADS'
export const CLEAR_REVIEW_LOADS = 'CLEAR_REVIEW_LOADS'
export const CLEAR_LOCKED_LOADS = 'CLEAR_LOCKED_LOADS'
export const CLEAR_CLOSED_LOADS = 'CLEAR_CLOSED_LOADS'
export const CLEAR_IN_PROGRESS_LOADS = 'CLEAR_IN_PROGRESS_LOADS'

export const FETCH_LOAD_RECEIPT = 'FETCH_LOAD_RECEIPT'

export const FETCH_RECEIVERS_BY_ID = 'FETCH_RECEIVERS_BY_ID'

export const PAGE_MARKET_LOADS = 'PAGE_MARKET_LOADS'
export const PAGE_HIRED_LOADS = 'PAGE_HIRED_LOADS'
export const PAGE_IN_TRANSIT_LOADS = 'PAGE_IN_TRANSIT_LOADS'
export const PAGE_DELIVERED_LOADS = 'PAGE_DELIVERED_LOADS'
export const PAGE_IN_PROGRESS_LOADS = 'PAGE_IN_PROGRESS_LOADS'

export const OPERATION_GROUPS_LOADS = 'OPERATION_GROUPS_LOADS'
export const SAVE_FILTERS_LOADS = 'SAVE_FILTERS_LOADS'

export const FETCH_LOAD_FOR_GROUP = 'FETCH_LOAD_FOR_GROUP'
export const FETCH_CONFIGURED_TABLE = 'FETCH_CONFIGURED_TABLE'
export const SET_AMOUNTS = 'SET_AMOUNTS'
export const SET_UPDATES = 'SET_UPDATES'
export const INCREMENT_UPDATES = 'INCREMENT_UPDATES'
export const SET_IDS = 'SET_IDS'
export const SET_LIST_SCROLL = 'SET_LIST_SCROLL'
export const SET_ALL_SCROLL = 'SET_ALL_SCROLL'
export const CLEAR_ALL_LOADS = 'CLEAR_ALL_LOADS'


export const COUNT_IS_LOADING_BY_STATUS = 'COUNT_IS_LOADING_BY_STATUS'
export const VIEW_COUNT_BY_STATUS = 'VIEW_COUNT_BY_STATUS'

export const HIDDEN_COUNT_BY_STATUS = 'HIDDEN_COUNT_BY_STATUS'
export const HIDDEN_ALL_COUNTERS = 'HIDDEN_ALL_COUNTERS'
